"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _migrationApi = require("../api/migrationApi");
var _MigrationLogDialog = _interopRequireDefault(require("./MigrationLogDialog.vue"));
var _customerOrderApi = require("@/api/customerOrderApi");
var _Export2Excel = require("@/vendor/Export2Excel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DataMigrationDialog',
  components: {
    MigrationLogDialog: _MigrationLogDialog.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      currentStep: 1,
      loading: false,
      isDragover: false,
      uploadedFile: null,
      uploadProgress: 0,
      uploadProgressStatus: '',
      uploadStatusText: '正在处理数据...',
      uploadStatusDesc: '请稍后，数据迁移可能需要一些时间',
      uploadSuccess: false,
      uploadFailed: false,
      failReason: '',
      taskId: '',
      pollTimer: null,
      form: {
        appId: '',
        fuCardId: '',
        remark: ''
      },
      rules: {
        appId: [{
          required: true,
          message: '请选择目标小程序',
          trigger: 'change'
        }]
      },
      customerList: [],
      fudouCardList: [],
      currentCustomerId: null
    };
  },
  computed: {
    fileIcon: function fileIcon() {
      if (!this.uploadedFile) return 'el-icon-document';
      var ext = this.uploadedFile.name.split('.').pop().toLowerCase();
      if (ext === 'xlsx' || ext === 'xls') return 'el-icon-document';
      if (ext === 'csv') return 'el-icon-document';
      return 'el-icon-document';
    },
    fileIconClass: function fileIconClass() {
      if (!this.uploadedFile) return '';
      var ext = this.uploadedFile.name.split('.').pop().toLowerCase();
      if (ext === 'xlsx') return 'file-excel';
      if (ext === 'xls') return 'file-excel';
      if (ext === 'csv') return 'file-csv';
      return '';
    }
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
      this.currentStep = 1;
      this.uploadSuccess = false;
      this.uploadProgress = 0;
      this.uploadedFile = null;
      this.loadCustomers();
    },
    close: function close() {
      this.dialogVisible = false;
      this.currentStep = 1;
      this.uploadSuccess = false;
      this.uploadFailed = false;
      this.failReason = '';
      this.uploadProgress = 0;
      this.taskId = '';
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.form = {
        appId: '',
        fuCardId: '',
        remark: ''
      };
      this.currentCustomerId = null;
      this.fudouCardList = [];
      this.uploadedFile = null;
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },
    nextStep: function nextStep() {
      if (this.currentStep === 2) {
        this.startMigration();
      } else {
        this.currentStep++;
      }
    },
    prevStep: function prevStep() {
      this.currentStep--;
    },
    loadCustomers: function () {
      var _loadCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _customerOrderApi.companyappAutoListApi)();
            case 1:
              res = _context.v;
              this.customerList = res || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取小程序列表失败', _t);
              this.$message.error('获取小程序列表失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCustomers() {
        return _loadCustomers.apply(this, arguments);
      }
      return loadCustomers;
    }(),
    onAppChange: function () {
      var _onAppChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(val) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.form.fuCardId = '';
              this.fudouCardList = [];
              if (!val) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return this.loadFudouCardList(val);
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onAppChange(_x) {
        return _onAppChange.apply(this, arguments);
      }
      return onAppChange;
    }(),
    loadFudouCardList: function () {
      var _loadFudouCardList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(appId) {
        var res, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _migrationApi.getFudouCardListByAppIdApi)(appId);
            case 1:
              res = _context3.v;
              this.fudouCardList = res || [];
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.error('获取福卡列表失败', _t2);
              this.$message.error('获取福卡列表失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadFudouCardList(_x2) {
        return _loadFudouCardList.apply(this, arguments);
      }
      return loadFudouCardList;
    }(),
    triggerUpload: function triggerUpload() {
      this.$refs.fileInputRef.click();
    },
    handleFileChange: function handleFileChange(e) {
      var file = e.target.files[0];
      if (file) {
        this.setFile(file);
      }
      e.target.value = '';
    },
    handleDrop: function handleDrop(e) {
      this.isDragover = false;
      var file = e.dataTransfer.files[0];
      if (file) {
        var ext = file.name.split('.').pop().toLowerCase();
        if (['xlsx', 'xls', 'csv'].includes(ext)) {
          this.setFile(file);
        } else {
          this.$message.warning('仅支持 .xlsx、.xls、.csv 格式文件');
        }
      }
    },
    setFile: function setFile(file) {
      this.uploadedFile = file;
    },
    removeFile: function removeFile() {
      this.uploadedFile = null;
    },
    formatFileSize: function formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    downloadTemplate: function downloadTemplate() {
      var header = ['手机号', 'openid', '姓名', '公司', '余额', '积分商城余额'];
      var data = [['13800138000', 'openid_example_001', '张三', '示例公司A', '100.00', '50'], ['13800138001', 'openid_example_002', '李四', '示例公司A', '200.00', '100'], ['13800138002', '', '王五', '示例公司B', '50.00', ''], ['13800138003', 'openid_example_004', '赵六', '示例公司B', '300.00', '200']];
      (0, _Export2Excel.export_json_to_excel)({
        header: header,
        data: data,
        filename: '数据迁移模板',
        bookType: 'xlsx',
        autoWidth: false
      });
      this.$message.success('模板下载成功，请按说明填写数据');
    },
    startMigration: function () {
      var _startMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var formData, res, taskId, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.uploadedFile) {
                _context4.n = 1;
                break;
              }
              this.$message.warning('请先上传文件');
              return _context4.a(2);
            case 1:
              if (this.form.fuCardId) {
                _context4.n = 2;
                break;
              }
              this.$message.warning('请选择福豆卡');
              return _context4.a(2);
            case 2:
              this.currentStep = 3;
              this.uploadProgress = 0;
              this.uploadProgressStatus = '';
              this.uploadStatusText = '正在上传文件...';
              this.uploadStatusDesc = '请稍后，不要关闭弹窗';
              _context4.p = 3;
              formData = new FormData();
              formData.append('file', this.uploadedFile);
              formData.append('appId', this.form.appId);
              formData.append('fuCardId', this.form.fuCardId);
              if (this.form.remark) {
                formData.append('remark', this.form.remark);
              }
              _context4.n = 4;
              return (0, _migrationApi.dataMigrationUploadApi)(formData);
            case 4:
              res = _context4.v;
              // 新版本响应格式：{ taskId, status, message }
              // 兼容旧版本：直接返回 taskId 字符串
              taskId = '';
              if (res && _typeof(res) === 'object' && res.taskId) {
                taskId = res.taskId;
              } else if (typeof res === 'string' && res.trim() !== '') {
                taskId = res.trim();
              }
              if (taskId) {
                _context4.n = 5;
                break;
              }
              this.uploadProgressStatus = 'exception';
              this.uploadStatusText = '迁移失败';
              this.uploadStatusDesc = '服务器未返回有效的任务ID，请稍后重试';
              this.uploadFailed = true;
              this.failReason = '服务器未返回有效的任务ID';
              return _context4.a(2);
            case 5:
              this.taskId = taskId;

              // 文件上传成功，开始轮询任务状态
              this.uploadProgress = 10;
              this.uploadStatusText = '数据迁移处理中...';
              this.uploadStatusDesc = '数据已提交，请稍候';
              this.startTaskPolling();
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t3 = _context4.v;
              this.uploadProgress = 0;
              this.uploadProgressStatus = 'exception';
              this.uploadStatusText = '迁移失败';
              this.uploadStatusDesc = _t3.message || '数据迁移过程中发生错误，请稍后重试';
              this.uploadFailed = true;
              this.failReason = _t3.message || '未知错误';
              this.$message.error('迁移失败: ' + (_t3.message || '未知错误'));
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[3, 6]]);
      }));
      function startMigration() {
        return _startMigration.apply(this, arguments);
      }
      return startMigration;
    }(),
    handleDone: function handleDone() {
      this.close();
    },
    resetMigrationState: function resetMigrationState() {
      this.uploadFailed = false;
      this.failReason = '';
      this.uploadProgress = 0;
      this.uploadProgressStatus = '';
      this.uploadStatusText = '正在处理数据...';
      this.uploadStatusDesc = '请稍后，数据迁移可能需要一些时间';
      this.currentStep = 2;
    },
    startTaskPolling: function startTaskPolling() {
      var _this = this;
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
      }
      var pollCount = 0;
      var maxPollCount = 100; // 最多轮询5分钟（100 * 3秒）
      this.pollTimer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var taskRes, baseProgress, progressRange, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              pollCount++;
              if (!(pollCount > maxPollCount)) {
                _context5.n = 1;
                break;
              }
              _this.clearPollTimer();
              _this.uploadProgressStatus = 'warning';
              _this.uploadStatusText = '任务处理超时';
              _this.uploadStatusDesc = '数据迁移任务处理时间较长，请稍后在「上传日志」中查看结果';
              _this.uploadFailed = true;
              _this.failReason = '任务处理超时，请稍后刷新查看结果';
              _this.$message.warning('迁移任务处理超时，请稍后在上传日志中查看结果');
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return (0, _migrationApi.getMigrationTaskStatusApi)(_this.taskId);
            case 2:
              taskRes = _context5.v;
              if (taskRes) {
                _context5.n = 3;
                break;
              }
              _this.clearPollTimer();
              _this.uploadProgressStatus = 'exception';
              _this.uploadStatusText = '任务状态查询失败';
              _this.uploadStatusDesc = '无法获取任务状态，请稍后重试';
              _this.uploadFailed = true;
              _this.failReason = '任务状态查询失败';
              return _context5.a(2);
            case 3:
              // 根据任务状态更新 UI
              if (taskRes.status === 'PROCESSING') {
                // 模拟进度：10% ~ 90%
                baseProgress = 30;
                progressRange = 60;
                _this.uploadProgress = Math.min(baseProgress + Math.floor(pollCount / maxPollCount * progressRange), 90);
                _this.uploadStatusText = '数据迁移处理中...';
                _this.uploadStatusDesc = taskRes.message || '正在处理数据，请稍候';
              } else if (taskRes.status === 'SUCCESS') {
                _this.clearPollTimer();
                _this.uploadProgress = 100;
                _this.uploadProgressStatus = 'success';
                _this.uploadStatusText = '迁移完成！';
                _this.uploadStatusDesc = '数据已成功迁移';
                _this.uploadSuccess = true;
                _this.$emit('refresh');
                _this.$message.success('数据迁移成功！');
              } else if (taskRes.status === 'FAILED') {
                _this.clearPollTimer();
                _this.uploadProgress = 0;
                _this.uploadProgressStatus = 'exception';
                _this.uploadStatusText = '迁移失败';
                _this.uploadStatusDesc = taskRes.message || '数据迁移过程中发生错误';
                _this.uploadFailed = true;
                _this.failReason = taskRes.message || '迁移失败';
                _this.$message.error('迁移失败: ' + (taskRes.message || '未知错误'));
              }
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t4 = _context5.v;
              console.error('轮询任务状态失败:', _t4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 4]]);
      })), 3000); // 3秒轮询一次
    },
    clearPollTimer: function clearPollTimer() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    openLogDialog: function openLogDialog() {
      this.$refs.MigrationLogDialogRef.open(null);
    }
  }
};